export default __webpack_public_path__ + "static/media/_nagorno-karabakh.cb927785.ico";